import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { Button } from 'onefaceui-react-components';
import Loading from 'react/components/Loading';

import ApplicationRulesModal from 'react/containers/modals/Survey/ApplicationRulesModal';

const FormSectionMemo = React.memo(({ errorCssRule, loadingInitialValues, onClickAction }) => (
  <FormSection
    className={`applicationRules ${errorCssRule}`}
    title="Survey.ApplyRules.ListTitle"
  >
    <FormSectionColumn>
      <div id="SurveyApplyRulesRulesListContainer" />
      {loadingInitialValues
        ? (<Loading width="30px" height="30px" theme="blue" />)
        : (
          <Button className="addItem" onClick={onClickAction}>
            {Monet.I18n.getResourcesByKey('Survey.ApplyRules.OpenModal')}
          </Button>
        )}
    </FormSectionColumn>
  </FormSection>
), (prevProps, nextProps) => prevProps.errorCssRule === nextProps.errorCssRule
    && prevProps.loadingInitialValues === nextProps.loadingInitialValues);

function ApplicationRulesSection({
  invalidSubmitCustom,
  invalidSubmitCustomAction,
  entity,
  loadingInitialValues,
  toggleApplicationRulesModalAction,
  modalIsOpen,
  ruleData
}) {
  const onClickAction = (e) => {
    e.preventDefault();

    invalidSubmitCustom
      && invalidSubmitCustomAction({ entity, invalidSubmitCustom: false });

    toggleApplicationRulesModalAction();
  };

  const errorCssRuleMemo = useMemo(
    () => (invalidSubmitCustom && Greenmile.Survey.SurveyApplyRule.data.length === 0 ? 'error-custom' : ''),
    [invalidSubmitCustom]
  );

  return (
    <>
      <ApplicationRulesModal
        isOpen={modalIsOpen}
        closeModalFn={toggleApplicationRulesModalAction}
        ruleData={ruleData}
      />
      <FormSectionMemo
        errorCssRule={errorCssRuleMemo}
        loadingInitialValues={loadingInitialValues}
        onClickAction={onClickAction}
      />
    </>
  );
}

ApplicationRulesSection.propTypes = {
  entity: PropTypes.string.isRequired,
  invalidSubmitCustom: PropTypes.bool.isRequired,
  invalidSubmitCustomAction: PropTypes.func.isRequired,
  loadingInitialValues: PropTypes.bool,
  modalIsOpen: PropTypes.bool,
  ruleData: PropTypes.object
};

const mapStateToProps = (state) => ({
  modalIsOpen: state.survey.getIn(['sections', 'applicationRules', 'modalIsOpen']),
  ruleData: state.survey.getIn(['sections', 'applicationRules', 'ruleData'])
});

export default connect(mapStateToProps)(React.memo(ApplicationRulesSection));
